
import React from 'react';
import { Music, BookOpen, Sparkles, Award, Target, Microscope } from 'lucide-react';

interface BenefitProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const Benefit = ({ icon, title, description }: BenefitProps) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 transition-transform hover:translate-y-[-5px]">
      <div className="w-12 h-12 flex items-center justify-center bg-piano-gold/10 text-piano-gold rounded-full mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-semibold mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const ExperiencedBenefits = () => {
  const benefits = [
    {
      icon: <Sparkles className="w-6 h-6" />,
      title: "Avanceret teknik",
      description: "Udvikling af avancerede tekniske færdigheder, der giver dig friheden til at spille krævende værker."
    },
    {
      icon: <Music className="w-6 h-6" />,
      title: "Musikalsk udtryk",
      description: "Forfin din evne til at udtrykke følelser og nuancer gennem dynamik, frasering og artikulation."
    },
    {
      icon: <BookOpen className="w-6 h-6" />,
      title: "Repertoireudvidelse",
      description: "Udforsk og mester et bredere repertoire af klassiske og moderne værker på tværs af forskellige stilarter."
    },
    {
      icon: <Microscope className="w-6 h-6" />,
      title: "Dybere forståelse",
      description: "Opnå en dybere forståelse af musikkens struktur, harmoni og historiske kontekst."
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: "Målrettet udvikling",
      description: "Personligt tilpasset undervisning, der fokuserer på dine specifikke udfordringer og mål."
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: "Koncertforberedelse",
      description: "Professionel vejledning i forberedelse til koncerter, konkurrencer eller optagelsesprøver."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">
            Fordele ved specialiseret undervisning for øvede pianister
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Min undervisning for øvede pianister er skræddersyet til at hjælpe dig med at overkomme tekniske barrierer og udvikle dit fulde potentiale som pianist.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <Benefit 
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperiencedBenefits;
